<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>产品管理</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>价格管理</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="tableAdd">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button class="qinang-button-margin" icon="user" @click="deviceSales">分配设备检票权限</a-button>
				<a-button class="qinang-button-margin" icon="user" @click="employeeSales">分配员工销售权限</a-button>
				<a-button class="qinang-button-margin" icon="desktop" @click="windowSales">分配窗口销售权限</a-button>
				<a-button icon="sync" @click="apiPriceQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="价格查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">价格编码：</div>
						<a-input v-model="query.priceCode" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiPriceQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						{{priceManageMain[0].facilitatorName}}
					</a-breadcrumb-item>
					<a-breadcrumb-item>
						{{priceManageMain[1].productName}}
					</a-breadcrumb-item>
				</a-breadcrumb>
				<a-tooltip placement="bottomRight">
					<template slot="title">
					  <span>返回上一级</span>
					</template>
					<a-button type="link" @click="backMainNavigation"><i class="icon-sjp-fanhui"></i></a-button>
				</a-tooltip>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="priceId" :loading="tableLoading" :pagination="false">
	
				<span slot="priceCode" slot-scope="priceCode">
					<a-button type="link" @click="edit(priceCode)" >{{priceCode.priceCode}}</a-button>
				</span>
				<span slot="productId" slot-scope="productId">
					{{priceManageMain[1].productName}}
				</span>
				<span slot="businesstypeId" slot-scope="businesstypeId">
					{{businesstypeMap['ywlx'+businesstypeId].businesstypeName}}
				</span>
				<span slot="crowdtypeId" slot-scope="crowdtypeId">
					{{crowdtypeMap['rqzl'+crowdtypeId].crowdtypeName}}
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-dropdown  :trigger="['click']">
						<a class="ant-dropdown-link" @click="e => e.preventDefault()">
						规则管理 <a-icon type="down" />
						</a>
						<a-menu slot="overlay">
							<a-menu-item key="0">
								<a-button type="link" @click="openBillingRule(tableAction)">计费规则</a-button>
							</a-menu-item>
							<a-menu-item key="1">
								<a-button type="link" @click="printTemplate(tableAction)">打印模板</a-button>
							</a-menu-item>
							<a-menu-item key="2">
								<a-button type="link" @click="priceDay(tableAction)">日期价格</a-button>
							</a-menu-item>
							<a-menu-item key="4">
								<a-button type="link" @click="priceDiscount(tableAction)">优惠政策</a-button>
							</a-menu-item>
							<a-menu-divider />
						</a-menu>
					</a-dropdown>
					<!-- <a-button type="link" >规则管理</a-button> -->
				</span>
				<span slot="listingPrice" slot-scope="listingPrice">
					{{listingPrice / 100}}
				</span>
				<span slot="salePrice" slot-scope="salePrice">
					{{salePrice / 100}}
				</span>
				<span slot="priceGroup" slot-scope="priceGroup">
					{{jgfzMap['jgfz'+priceGroup].valueA}}
				</span>
				<span slot="onlineSale" slot-scope="onlineSale">
					<span v-if="onlineSale == 2">否</span>
					<span v-if="onlineSale == 3">是</span>
				</span>
				<span slot="sceneSale" slot-scope="sceneSale">
					<span v-if="sceneSale == 2">否</span>
					<span v-if="sceneSale == 3">是</span>
				</span>
				
				<span slot="priceState" slot-scope="priceState">
					<span v-if="priceState == 2">禁用</span>
					<span v-if="priceState == 3">启用</span>
				</span>
				
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->
		<a-modal class="qa-modal" title="添加" width="100%" :visible="addVisible"  @cancel="addHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
	
					<a-form-model-item label="产品名称" >
						{{priceManageMain[1].productName}}
					</a-form-model-item>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格代码" has-feedback prop="priceCode">
							<a-input v-model="addForm.priceCode" placeholder="请输入价格代码" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：建议输入6位以内数字或字母组合的值，此值可用作售票软件快捷键)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="人群种类" has-feedback prop="crowdtypeId">
							<a-select v-model="addForm.crowdtypeId">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in crowdtypeList" :key="index" :value="item.crowdtypeId">{{item.crowdtypeName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="业务类型" has-feedback prop="businesstypeId">
							<a-select v-model="addForm.businesstypeId">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in businesstypeList" :key="index" :value="item.businesstypeId">{{item.businesstypeName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格开始日期" has-feedback prop="startDate">
							 <a-date-picker v-model="addForm.startDate" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(例：2021-08-01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格结束日期" has-feedback prop="endDate">
							 <a-date-picker v-model="addForm.endDate" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(例：2021-08-01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否实名制" has-feedback prop="isRealName">
							<a-radio-group name="isRealName" v-model="addForm.isRealName">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="三方系统ID" has-feedback prop="thirdSkuId">
							<a-input v-model="addForm.thirdSkuId" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：第三方系统ID，用于匹配三方系统中的商品)</div>
					</div>
					<a-form-model-item label="采集类型" has-feedback prop="collectionType">
						<a-radio-group name="collectionType" v-model="addForm.collectionType">
							<a-radio :value="2">不采集</a-radio>
							<a-radio :value="3">采集指纹</a-radio>
							<a-radio :value="4">采集人脸</a-radio>
						</a-radio-group>
					</a-form-model-item>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="挂牌价" has-feedback prop="listingPrice">
							<a-input v-model="addForm.listingPrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="实际售价" has-feedback prop="salePrice">
							<a-input v-model="addForm.salePrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="结算价" has-feedback prop="settlementPrice">
							<a-input v-model="addForm.settlementPrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格排序" has-feedback prop="priceSort">
							<a-input v-model="addForm.priceSort" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：请输入9位以内数字，排序为从大到小)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="库存设置" has-feedback prop="inventoryType">
							<a-select v-model="addForm.inventoryType">
								<a-select-option :value="0">不限制</a-select-option>
								<!-- <a-select-option :value="3">限制</a-select-option> -->
							</a-select>
						</a-form-model-item>
						<!-- <div class="qa-table-item-1-remarks-right" style=""></div> -->
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否网上销售" has-feedback prop="isRealName">
							<a-radio-group name="onlineSale" v-model="addForm.onlineSale">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否现场销售" has-feedback prop="isRealName">
							<a-radio-group name="sceneSale" v-model="addForm.sceneSale">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格分组" has-feedback prop="priceGroup">
							<a-select v-model="addForm.priceGroup">
								<a-select-option value="">请选择</a-select-option>
								<a-select-option v-for="(item,index) in jgfzList" :key="index" :value="item.sysparmName">{{item.valueA}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否启用" has-feedback prop="priceState">
							<a-radio-group name="priceState" v-model="addForm.priceState">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="计时票" has-feedback >
							<a-radio-group name="overtimeTime" v-model="addForm.isOvertime" @change="handleOvertimeTimeChange">
								<a-radio :value="parseInt('-2')">否</a-radio>
								<a-radio :value="parseInt('0')">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks" v-if="addForm.isOvertime == 0">
						<a-form-model-item label="初始费" has-feedback prop="initialAmount">
							<a-input-number v-model="addForm.initialAmount" placeholder="请输入初始费" min="0" :formatter="value => `${value}元`"
      							:parser="value => value.replace('元', '')" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：核销后，最低消费金额)</div>
					</div>
					<div class="qa-table-item-1-remarks" v-if="addForm.isOvertime == 0">
						<a-form-model-item label="超时时间" has-feedback prop="overtimeTime">
							<a-input-number v-model="addForm.overtimeTime" placeholder="请输入超时时间" :formatter="value => `${value}分钟`"
      							:parser="value => value.replace('分钟', '')" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：超过当前设置时间后，将额外进行收费，-1代表不设超时限制)</div>
					</div>
					<div class="qa-table-item-1-remarks" v-if="addForm.isOvertime == 0">
						<a-form-model-item label="超时设置" has-feedback prop="overtimeTime" >
							<a-input-group compact>
								<a-input-number v-model="addForm.overtimeCycle" style="width: 45%" min="0"
								:formatter="value => `${value}分钟`"
      							:parser="value => value.replace('分钟', '')" />
								/
								<a-input-number v-model="addForm.overtimePrice" style="width: 45%" min="0" :formatter="value => `${value}元`"
      							:parser="value => value.replace('元', '')" />
							</a-input-group>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：超时后，每隔N分钟收费N元)</div>
					</div>
					<div class="qa-table-item-1-remarks" v-if="addForm.isOvertime == 0">
						<a-form-model-item label="封顶金额" has-feedback prop="cappedAmount">
							<a-input-number v-model="addForm.cappedAmount" placeholder="请输入封顶金额" min="0" :formatter="value => `${value}元`"
      							:parser="value => value.replace('元', '')" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：订单额外计费后总金额不能超过此值，单位元)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="语音提示" has-feedback prop="voicePrompt">
							<a-input v-model="addForm.voicePrompt" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：输入语音文件名称，用于闸机或手持机等检票设备播放语音提示)</div>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback prop="remarks">
							<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
						</a-form-model-item>
					</div>
					
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="addVisible = false">返回</a-button>
						<a-button type="primary" @click="addHandleOk">保存</a-button>
					</div>
				</a-form-model>
			</div>
			
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal" title="修改" width="100%" :visible="editVisible"  @cancel="editHandleCancel" :footer="null" :maskClosable="false" :keyboard="false">
			<div style="width: 80%;background-color: #fff;">
				<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
					<a-form-model-item label="产品名称" >
						{{priceManageMain[1].productName}}
					</a-form-model-item>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格代码" has-feedback prop="priceCode">
							<a-input v-model="editForm.priceCode" placeholder="请输入价格代码" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：建议输入6位以内数字或字母组合的值，此值可用作售票软件快捷键)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="人群种类" has-feedback prop="crowdtypeId">
							<a-select v-model="editForm.crowdtypeId">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in crowdtypeList" :key="index" :value="item.crowdtypeId">{{item.crowdtypeName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="业务类型" has-feedback prop="businesstypeId">
							<a-select v-model="editForm.businesstypeId">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in businesstypeList" :key="index" :value="item.businesstypeId">{{item.businesstypeName}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格开始日期" has-feedback prop="startDate">
							 <a-date-picker v-model="editForm.startDate" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(例：2021-08-01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格结束日期" has-feedback prop="endDate">
							 <a-date-picker v-model="editForm.endDate" format="YYYY-MM-DD"/>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(例：2021-08-01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否实名制" has-feedback prop="isRealName">
							<a-radio-group name="isRealName" v-model="editForm.isRealName">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="三方系统ID" has-feedback prop="thirdSkuId">
							<a-input v-model="editForm.thirdSkuId" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：第三方系统ID，用于匹配三方系统中的商品)</div>
					</div>
					
					<a-form-model-item label="采集类型" has-feedback prop="collectionType">
						<a-radio-group name="collectionType" v-model="editForm.collectionType">
							<a-radio :value="2">不采集</a-radio>
							<a-radio :value="3">采集指纹</a-radio>
							<a-radio :value="4">采集人脸</a-radio>
						</a-radio-group>
					</a-form-model-item>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="挂牌价" has-feedback prop="listingPrice">
							<a-input v-model="editForm.listingPrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="实际售价" has-feedback prop="salePrice">
							<a-input v-model="editForm.salePrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="结算价" has-feedback prop="settlementPrice">
							<a-input v-model="editForm.settlementPrice" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格排序" has-feedback prop="priceSort">
							<a-input v-model="editForm.priceSort" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：请输入9位以内数字，排序为从大到小)</div>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="库存设置" has-feedback prop="inventoryType">
							<a-select v-model="editForm.inventoryType">
								<a-select-option :value="0">不限制</a-select-option>
								<!-- <a-select-option :value="3">限制</a-select-option> -->
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否网上销售" has-feedback prop="isRealName">
							<a-radio-group name="onlineSale" v-model="editForm.onlineSale">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否现场销售" has-feedback prop="isRealName">
							<a-radio-group name="sceneSale" v-model="editForm.sceneSale">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="价格分组" has-feedback prop="priceGroup">
							<a-select v-model="editForm.priceGroup">
								<a-select-option value="">请选择</a-select-option>
								<a-select-option v-for="(item,index) in jgfzList" :key="index" :value="item.sysparmName">{{item.valueA}}</a-select-option>
							</a-select>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="是否启用" has-feedback prop="priceState">
							<a-radio-group name="priceState" v-model="editForm.priceState">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="日期票" has-feedback prop="priceDayState">
							<a-radio-group name="priceDayState" v-model="editForm.priceDayState">
								<a-radio :value="2">否</a-radio>
								<a-radio :value="3">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="计时票" has-feedback >
							<a-radio-group name="overtimeTime" v-model="editForm.isOvertime" @change="handleOvertimeTimeChange">
								<a-radio :value="parseInt('-2')">否</a-radio>
								<a-radio :value="parseInt('0')">是</a-radio>
							</a-radio-group>
						</a-form-model-item>
					</div>
					<div class="qa-table-item-1-remarks" v-if="editForm.isOvertime == 0">
						<a-form-model-item label="初始费" has-feedback prop="initialAmount">
							<a-input-number v-model="editForm.initialAmount" placeholder="请输入初始费" min="0" 
							:formatter="value => `${value}元`"
      						:parser="value => value.replace('元', '')" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：核销后，最低消费金额。支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks" v-if="editForm.isOvertime == 0">
						<a-form-model-item label="超时时间" has-feedback prop="overtimeTime">
							<a-input-number v-model="editForm.overtimeTime" placeholder="请输入超时时间"
      							:formatter="value => `${value}分钟`"
      							:parser="value => value.replace('分钟', '')" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：超过当前设置时间后，将额外进行收费，-1代表不设超时限制)</div>
					</div>
					<div class="qa-table-item-1-remarks" v-if="editForm.isOvertime == 0">
						<a-form-model-item label="超时设置" has-feedback prop="overtimeTime" >
							<a-input-group compact>
								<a-input-number v-model="editForm.overtimeCycle" style="width: 45%" min="0"
      							:formatter="value => `${value}分钟`"
      							:parser="value => value.replace('分钟', '')" />
								/
								<a-input-number v-model="editForm.overtimePrice" style="width: 45%" min="0"
								:formatter="value => `${value}元`"
      							:parser="value => value.replace('元', '')" />
							</a-input-group>
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：超时后，每隔N分钟收费N元。支持最小单位分，例：1.01)</div>
					</div>
					<div class="qa-table-item-1-remarks" v-if="editForm.isOvertime == 0">
						<a-form-model-item label="封顶金额" has-feedback prop="cappedAmount">
							<a-input-number v-model="editForm.cappedAmount" placeholder="请输入封顶金额" min="0"
							:formatter="value => `${value}元`"
      						:parser="value => value.replace('元', '')" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：订单额外计费后总金额不能超过此值，单位元。支持最小单位分，例：1.01)</div>
					</div>
					
					<div class="qa-table-item-1-remarks">
						<a-form-model-item label="语音提示" has-feedback prop="voicePrompt">
							<a-input v-model="editForm.voicePrompt" placeholder="请输入" />
						</a-form-model-item>
						<div class="qa-table-item-1-remarks-right" style="">(注：输入语音文件名称，用于闸机或手持机等检票设备播放语音提示)</div>
					</div>
					<div class="qa-table-item-1">
						<a-form-model-item label="备注" has-feedback prop="remarks">
							<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
						</a-form-model-item>
					</div>
					<div style="text-align: center;">
						<a-button style="margin-right: 20px;" @click="editVisible = false">返回</a-button>
						<a-button type="primary" @click="editHandleOk">保存</a-button>
					</div>
					
				</a-form-model>
			</div>
			
		</a-modal>

		<!-- 窗口设备弹窗 -->
		<a-modal title="权限管理" width="80%" :visible="windowVeisible" :confirm-loading="windowConfirmLoading" @ok="windowHandleOk" @cancel="windowVeisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model  :model="editForm" :label-col="{span: 2}" :wrapper-col="{span: 22}" >
				<a-form-model-item label="权限" has-feedback>
					<a-transfer :titles="['未选权限', '已选权限']" :data-source="allData" :render="item => item.title" :list-style="{ width: '40%', height: '300px',}" :target-keys="selectKeys" @change="handleWindowChange"/>				
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 设备权限弹窗 -->
		<a-modal title="权限管理" width="80%" :visible="deviceVeisible" :confirm-loading="deviceConfirmLoading" @ok="deviceHandleOk" @cancel="deviceVeisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model  :model="editForm" :label-col="{span: 2}" :wrapper-col="{span: 22}" >
				<a-form-model-item label="权限" has-feedback>
					<a-transfer :titles="['未选权限', '已选权限']" :data-source="allData" :render="item => item.title" :list-style="{ width: '40%', height: '300px',}" :target-keys="selectKeys" @change="handleDeviceChange"/>				
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<!-- 员工权限弹窗 -->
		<a-modal title="权限管理" width="80%" :visible="employeeVeisible" :confirm-loading="employeeConfirmLoading" @ok="employeeHandleOk" @cancel="employeeVeisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model  :model="editForm" :label-col="{span: 2}" :wrapper-col="{span: 22}" >
				<a-form-model-item label="权限" has-feedback>
					<a-transfer :titles="['未选权限', '已选权限']" :data-source="allData" :render="item => item.title" :list-style="{ width: '40%', height: '300px',}" :target-keys="selectKeys" @change="handleEmployeeChange"/>				
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<!-- 计费规则弹窗 -->
		<a-modal title="计费规则" width="80%" :visible="billingRuleVisible" :confirm-loading="billingRuleConfirmLoading" @ok="billingRuleHandleOk" @cancel="billingRuleVisible = false" :maskClosable="false" :keyboard="false" >
			<BillingRuleFrom v-if="billingRuleVisible" ref="billingRuleFrom" :price-id="priceId" @close="closeBillingRule" />
		</a-modal>
		<!-- 打印模板弹窗 -->
		<a-modal title="打印模板" width="60%" :visible="printTemplateVisible" :confirm-loading="printTemplateConfirmLoading" @ok="printTemplateHandleOk" @cancel="printTemplateVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model  :model="printTemplateForm" :label-col="{span: 2}" :wrapper-col="{span: 22}" >
				<a-form-model-item label="门票模板" has-feedback prop="printTemplateId">
					<a-select placeholder="请选择门票模板" v-model="printTemplateForm.printTemplateId">
						<a-select-option v-for="item in printTemplateList" :key="item.printTemplateId" :value="item.printTemplateId">{{item.templateName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="副卷模板" has-feedback prop="printSubTemplateId">
					<a-select placeholder="请选择副卷模板" v-model="printTemplateForm.printSubTemplateId">
						<a-select-option v-for="item in printSubTemplateList" :key="item.printTemplateId" :value="item.printTemplateId">{{item.templateName}}</a-select-option>
					</a-select>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<!-- 日价格弹窗 -->
		<a-modal class="qa-modal-day" title="日期价格" width="100%"  :visible="priceDayVisible" :confirm-loading="priceDayConfirmLoading" :footer="null" @cancel="priceDayVisible = false" :maskClosable="false" :keyboard="false" >
			<PriceDay v-if="priceDayVisible" ref="priceDayFrom" :price-id="priceId" :start-date="startDate" :end-date="endDate" :default-sale-price="salePrice" :default-settlement-price="settlementPrice" />
		</a-modal>
		<!-- 优惠政策 -->
		 <a-modal title="优惠政策" width="60%" :visible="priceDiscountVisible" :confirm-loading="priceDiscountConfirmLoading" @ok="priceDiscountHandleOk" @cancel="priceDiscountVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model  :model="priceDiscountForm" :label-col="{span: 2}" :wrapper-col="{span: 22}" >
				<a-form-model-item label="优惠政策" has-feedback prop="priceDiscountId">
					<a-select placeholder="请选择优惠政策" v-model="priceDiscountForm.priceDiscountId">
						<a-select-option v-for="item in priceDiscountList" :key="item.priceDiscountId" :value="item.priceDiscountId">{{item.title}}</a-select-option>
					</a-select>
				</a-form-model-item>
			</a-form-model>
		 </a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	import BillingRuleFrom from './BillingRuleFrom.vue';
	import PriceDay from './PriceDay.vue';
		
	export default {
		components: {
			BillingRuleFrom,
			PriceDay
		},
		data() {
			return {
				moment,
				priceManageMain: JSON.parse(window.sessionStorage.getItem('priceManageMain')),
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				jgfzList: {},
				jgfzMap: [],
				crowdtypeList: {},
				crowdtypeMap: [],
				businesstypeList: {},
				businesstypeMap: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					productId: (JSON.parse(window.sessionStorage.getItem('priceManageMain')))[1].productId,
					priceCode: '',
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'priceId', key:'priceId', align:'center'},
					{ title:'价格编码', key:'priceCode', align:'center', scopedSlots:{customRender:'priceCode'}},
					{ title:'产品名称', key:'productId', align:'center', scopedSlots:{customRender:'productId'}},
					{ title:'业务', key:'businesstypeId', dataIndex:'businesstypeId', align:'center', scopedSlots:{customRender:'businesstypeId'}},
					{ title:'人群种类', key:'crowdtypeId', dataIndex:'crowdtypeId',align:'center', scopedSlots:{customRender:'crowdtypeId'}},
					{ title:'操作', key:'tableAction', align:'center', scopedSlots:{customRender:'tableAction'}},
					{ title:'价格开始日期', dataIndex:'startDate', key:'startDate', align:'center'},
					{ title:'价格结束日期', dataIndex:'endDate', key:'endDate', align:'center'},
					{ title:'挂牌价', dataIndex:'listingPrice', key:'listingPrice', align:'center', scopedSlots:{customRender:'listingPrice'}},
					{ title:'实际售价', dataIndex:'salePrice', key:'salePrice', align:'center', scopedSlots:{customRender:'salePrice'}},
					{ title:'价格分组', key:'priceGroup', dataIndex:'priceGroup',align:'center', scopedSlots:{customRender:'priceGroup'}},
					{ title:'网上销售', dataIndex:'onlineSale', key:'onlineSale', align:'center', scopedSlots:{customRender:'onlineSale'}},
					{ title:'现场销售', dataIndex:'sceneSale', key:'sceneSale', align:'center', scopedSlots:{customRender:'sceneSale'}},
					{ title:'排序', dataIndex:'priceSort', key:'priceSort', align:'center' },
					
					{ title:'状态', dataIndex:'priceState', key:'priceState', align:'center', scopedSlots:{customRender:'priceState'}},
					
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					facilitatorId: 0,
					productId: 0,
					priceCode: '',
					crowdtypeId: 0,
					businesstypeId: 0,	
					startDate: moment(),
					endDate: moment(),
					isRealName: 2,
					collectionType: 2,
					listingPrice: 0,
					salePrice: 0,
					settlementPrice: 0,
					priceSort: 0,
					inventoryType: 0,
					onlineSale: 2,
					sceneSale: 3,
					priceGroup: '',
					priceState: 3,
					priceDayState: 2,
					isOvertime: -2,
					overtimeTime: -2,
					initialAmount: 0,
					overtimeCycle: 0,
					overtimePrice: 0,
					cappedAmount: 0,
					voicePrompt: '',
					remarks: '',
					thirdSkuId: '',
				},
				addRules: {
					priceCode: [{ required: true, message: '产品代码不能为空', trigger: 'blur' }],
					crowdtypeId: [{ required: true, type: 'number', min: 1, message: '请选择', trigger: 'blur' }],
					businesstypeId: [{ required: true, type: 'number', min: 1, message: '请选择', trigger: 'blur' }],
					startDate: [
						{ required: true, message: '请选择', trigger: 'blur' },
						{
							validator: (rule, value, callback) => {
								if (value && this.addForm.endDate) {
									const start = new Date(value);
									const end = new Date(this.addForm.endDate);
									const diffTime = Math.abs(end - start);
									const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
									if (diffDays > 730) {
										callback(new Error('日期跨度不能超过2年'));
									} else {
										callback();
									}
								} else {
									callback();
								}
							},
							trigger: 'change'
						}
					],
					endDate: [
						{ required: true, message: '请选择', trigger: 'blur' },
						{
							validator: (rule, value, callback) => {
								if (value && this.addForm.startDate) {
									const start = new Date(this.addForm.startDate);
									const end = new Date(value);
									const diffTime = Math.abs(end - start);
									const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
									if (diffDays > 730) {
										callback(new Error('日期跨度不能超过2年'));
									} else {
										callback();
									}
								} else {
									callback();
								}
							},
							trigger: 'change'
						}
					],
					isRealName: [{ required: true, message: '请选择', trigger: 'blur' }],
					collectionType: [{ required: true, message: '请选择', trigger: 'blur' }],
					listingPrice: [{ required: true, message: '请输如整数或小数', trigger: 'blur' }],
					salePrice: [{ required: true, message: '请输如整数或小数', trigger: 'blur' }],
					settlementPrice: [{ required: true, message: '请输如整数或小数', trigger: 'blur' }],
					onlineSale: [{ required: true, message: '请选择', trigger: 'blur' }],
					sceneSale: [{ required: true, message: '请选择', trigger: 'blur' }],
					priceGroup: [{ required: true, message: '请选择', trigger: 'blur' }],
					priceState: [{ required: true, message: '请选择', trigger: 'blur' }],
					priceDayState: [{ required: true, message: '请选择', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					productId: '',
					facilitatorId: '',
					productName: '',
					productCode: '',
					productClass: 2,
					checkType: 2,
					useType: 2,
					outType: 2,
					mediumClass: 2,
					productState: 2,
					priceDayState: 2,
					remarks: '',
					thirdSkuId: '',
				},
				// 修改弹窗-end
				// 窗口权限-star
				windowVeisible: false,
				windowConfirmLoading: false,
				// 窗口权限-end
				// 设备权限-start
				deviceVeisible: false,
				deviceConfirmLoading: false,
				// 设备权限-end
				// 员工权限-start
				employeeVeisible: false,
				employeeConfirmLoading: false,
				// 员工权限-end
				allData: [],
				delKeys: [],
				selectKeys: [],
				//规则管理-start
				//计费规则
				billingRuleVisible: false,
				billingRuleConfirmLoading: false,
				
				//日价格
				priceDayVisible: false,
				priceDayConfirmLoading: false,

				priceId: 0,
				startDate: '',
				endDate: '',
				salePrice: 0,
				settlementPrice: 0,
				//打印模板
				printTemplateVisible: false,
				printTemplateConfirmLoading: false,
				printTemplateForm: {
					priceConfigId: 0,
					printTemplateId : 0,
					printSubTemplateId : 0,
				},	
				printTemplateList: [],
				printSubTemplateList: [],
				//优惠政策
				priceDiscountVisible: false,
				priceDiscountConfirmLoading: false,
				priceDiscountForm: {
					priceConfigId: 0,
					priceDiscountId: 0,
				},	
				priceDiscountList: [],
				//规则管理-end

			};
		},
		methods: {
			//返回
			backMainNavigation(){
				this.$router.push('/BasicTicket');
			},
			//获取价格分组
			async apiSysparmListByName() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSysparmListByName, {sysparmName: 'JGFZ'});
				if (res.code == 200) {
					this.jgfzList = res.data
					for(let i=0; i<res.data.length; i++) {
						this.jgfzMap['jgfz'+res.data[i].sysparmName] = res.data[i]
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取人群种类
			async apiCrowdtypeList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCrowdtypeList);
				if (res.code == 200) {
					this.crowdtypeList = res.data
					for(let i=0; i<res.data.length; i++) {
						this.crowdtypeMap['rqzl'+res.data[i].crowdtypeId] = res.data[i]
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取业务类型
			async apiBusinesstypeList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiBusinesstypeList);
				if (res.code == 200) {
					this.businesstypeList = res.data
					for(let i=0; i<res.data.length; i++) {
						this.businesstypeMap['ywlx'+res.data[i].businesstypeId] = res.data[i]
					}
				} else {
					this.$message.error(res.msg)
				}
			},
			// 获取打印模板
			async apiPrintTemplateList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPrintTemplateList, {});
				if (res.code == 200) {
					const templateList = res.data
					let printTemplateList = [{
						printTemplateId: 0,
						templateName: '未选择门票模板',
						templateJson: '',
					}]
					let printSubTemplateList = [{
						printTemplateId: 0,
						templateName: '未选择副卷模板',
						templateJson: '',
					}]
					for(let i=0; i<templateList.length; i++) {
						if(templateList[i].type == "z_card"){
							printTemplateList.push({
								printTemplateId: templateList[i].printTemplateId,
								templateName: templateList[i].templateName,
								templateJson: templateList[i].templateJson,
							})
						}else{
							printSubTemplateList.push({
								printTemplateId: templateList[i].printTemplateId,
								templateName: templateList[i].templateName,
								templateJson: templateList[i].templateJson,
							})
						}
					}
					this.printTemplateList = printTemplateList
					this.printSubTemplateList = printSubTemplateList
				} else {
					this.$message.error(res.msg)
				}
			},
			// 获取优惠政策
			async apiPriceDiscountList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceDiscountList, {});
				if (res.code == 200) {
					console.log(res.data)
					let priceDiscountList = [{
						priceDiscountId: 0,
						title: '未选择优惠政策',
					}]
					for(let i=0; i<res.data.length; i++) {
						priceDiscountList.push({
							priceDiscountId: res.data[i].priceDiscountId,
							title: res.data[i].title,
						})
					}
					this.priceDiscountList = priceDiscountList
				} else {
					this.$message.error(res.msg)
				}
			},
			//--------------表格开始-搜索
			async apiPriceQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiPriceQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiPriceQueryList()
			},
			handleOvertimeTimeChange(val) {
				if(val == -2){
					this.addForm.overtimeTime = -2
					this.editForm.overtimeTime = -2
				}else{
					this.addForm.overtimeTime = 0
					this.editForm.overtimeTime = 0
				}

			},
			tableAdd() {
				this.addForm.isOvertime = -2
				this.addVisible = true
			},
			async apiPriceAdd() {
				let data = JSON.parse(JSON.stringify(this.addForm))
				data.facilitatorId = this.priceManageMain[0].facilitatorId
				data.productId = this.priceManageMain[1].productId
				data.listingPrice = this.addForm.listingPrice * 100
				data.salePrice = this.addForm.salePrice * 100
				data.settlementPrice = this.addForm.settlementPrice * 100
				data.initialAmount = this.addForm.initialAmount * 100
				data.overtimePrice = this.addForm.overtimePrice * 100
				data.cappedAmount = this.addForm.cappedAmount * 100
				data.startDate = this.addForm.startDate.format('YYYY-MM-DD')
				data.endDate = this.addForm.endDate.format('YYYY-MM-DD')
				data.thirdSkuId = this.addForm.thirdSkuId.trim()
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceAdd, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiPriceQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiPriceAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				items.productId = this.priceManageMain[1].productId
				items.listingPrice = item.listingPrice / 100
				items.salePrice = item.salePrice / 100
				items.settlementPrice = item.settlementPrice / 100
				items.startDate = this.moment(item.startDate)
				items.endDate = this.moment(item.endDate)
				items.isOvertime = item.overtimeTime == -2 ? -2 : 0
				items.initialAmount = item.initialAmount / 100
				items.overtimePrice = item.overtimePrice / 100
				items.cappedAmount = item.cappedAmount / 100
				items.thirdSkuId = item.thirdSkuId || ''
				this.editForm = items
				this.editVisible = true
			},
			async apiPriceEdit() {
				let data = JSON.parse(JSON.stringify(this.editForm))
				data.facilitatorId = this.priceManageMain[0].facilitatorId
				data.listingPrice = this.editForm.listingPrice * 100
				data.salePrice = this.editForm.salePrice * 100
				data.settlementPrice = this.editForm.settlementPrice * 100
				data.initialAmount = this.editForm.initialAmount * 100
				data.overtimePrice = this.editForm.overtimePrice * 100
				data.cappedAmount = this.editForm.cappedAmount * 100
				data.startDate = this.editForm.startDate.format('YYYY-MM-DD')
				data.endDate = this.editForm.endDate.format('YYYY-MM-DD')
				data.thirdSkuId = this.editForm.thirdSkuId.trim()
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceEdit, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiPriceQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiPriceEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.productId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.departmentName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiPriceDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiPriceDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceDel, {priceId: this.tableSelectedRows.priceId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiPriceQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.productId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
			//-----------------员工销售权限--------
			employeeSales(){
				if(this.tableSelectedRows.productId > 0) {
					this.apiPriceGetStaffRules(this.tableSelectedRows);
				}else{
					this.$message.warning('请选择要分配的数据');
				}
			},
			async apiPriceGetStaffRules(item){
				this.allData = []
				this.selectKeys = []
				this.delKeys = []

				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceGetStaffRules, {facilitatorId: item.facilitatorId, priceId: item.priceId});
				if (res.code == 200) {
					this.allData = res.data.all
					for(let i=0; i<this.allData.length; i++){
						this.allData[i].key = this.allData[i].staffId + '-' + item.productId
						this.allData[i].title = this.allData[i].staffName + '(' + this.allData[i].enterpriseName + ')'
					}
					for(let i=0; i<res.data.self.length; i++){
						this.selectKeys.push(res.data.self[i].staffId + '-' + item.productId)
					}
					this.delKeys = JSON.parse(JSON.stringify(this.selectKeys))
					this.employeeVeisible = true
				} else{
					this.$message.error(res.msg)
					this.employeeConfirmLoading = false
					this.employeeVeisible = false
				}
			},
			employeeHandleOk(){
				this.apiSalestaffEdit();
			},
			async apiSalestaffEdit() {
				this.employeeConfirmLoading = true
				let addKeys = []
				for(let i=0; i<this.selectKeys.length; i++){
					let is = this.delKeys.indexOf(this.selectKeys[i])
					if(is > -1){
						this.delKeys.splice(is, 1)
					}else{
						addKeys.push(this.selectKeys[i])
					}
				}
				const { data: res } = await this.$http.post(this.navigation.apiSalestaffEditByPrice, {
					priceId:this.tableSelectedRows.priceId, delKeys:this.delKeys, addKeys:addKeys,
				});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiPriceQueryList()
					this.employeeConfirmLoading = false
					this.employeeVeisible = false
				} else {
					this.$message.error(res.msg)
					this.employeeConfirmLoading = false
				}
			},
			handleEmployeeChange(targetKeys, direction, moveKeys){
				this.selectKeys = targetKeys;
			},
			//-----------------设备检票权限--------
			deviceSales(){
				if(this.tableSelectedRows.productId > 0) {
					this.apiPriceGetDeviceRules(this.tableSelectedRows);
				}else{
					this.$message.warning('请选择要分配的数据');
				}
			},
			async apiPriceGetDeviceRules(item){
				this.allData = []
				this.selectKeys = []
				this.delKeys = []
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceGetDeviceRules, {facilitatorId: item.facilitatorId, priceId: item.priceId});
				if (res.code == 200) {
					this.allData = res.data.all
					for(let i=0; i<this.allData.length; i++){
						this.allData[i].key = this.allData[i].checkDeviceId + '-' + this.allData[i].checkStationId + '-' + item.productId + "-" + item.facilitatorId
						this.allData[i].title = this.allData[i].checkDeviceName + '(' + this.allData[i].checkStationName + ')'
					}
					for(let i=0; i<res.data.self.length; i++){
						this.selectKeys.push(res.data.self[i].checkDeviceId + '-' + res.data.self[i].checkStationId + '-' + res.data.self[i].productId + "-" + item.facilitatorId)
					}
					this.delKeys = JSON.parse(JSON.stringify(this.selectKeys))
					this.deviceVeisible = true
				} else {
					this.$message.error(res.msg)
				}
			},
			deviceHandleOk(){
				this.apiSaleDeviceEdit();
			},
			async apiSaleDeviceEdit() {
				this.deviceConfirmLoading = true
				let addKeys = []
				for(let i=0; i<this.selectKeys.length; i++){
					let is = this.delKeys.indexOf(this.selectKeys[i])
					if(is > -1){
						this.delKeys.splice(is, 1)
					}else{
						addKeys.push(this.selectKeys[i])
					}
				}
				const { data: res } = await this.$http.post(this.navigation.apiSaleDeviceEditByPrice, {
					priceId:this.tableSelectedRows.priceId, delKeys:this.delKeys, addKeys:addKeys,
				});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiPriceQueryList()
					this.deviceConfirmLoading = false
					this.deviceVeisible = false
				} else {
					this.$message.error(res.msg)
					this.deviceConfirmLoading = false
				}
			},
			handleDeviceChange(targetKeys, direction, moveKeys){
				this.selectKeys = targetKeys;
			},
			//-----------------窗口销售权限--------
			windowSales(){
				if(this.tableSelectedRows.productId > 0) {
					this.apiPriceGetWindowRules(this.tableSelectedRows);
				}else{
					this.$message.warning('请选择要分配的数据');
				}
			},
			async apiPriceGetWindowRules(item){
				this.allData = []
				this.selectKeys = []
				this.delKeys = []
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceGetWindowRules, {facilitatorId: item.facilitatorId, priceId: item.priceId});
				if (res.code == 200) {
					this.allData = res.data.all
					for(let i=0; i<this.allData.length; i++){
						this.allData[i].key = this.allData[i].ticketwindowId + '-' + item.productId
						this.allData[i].title = this.allData[i].ticketwindowName + '(' + this.allData[i].ticketstationName + ')'
					}
					for(let i=0; i<res.data.self.length; i++){
						this.selectKeys.push(res.data.self[i].ticketwindowId + '-' + res.data.self[i].productId)
					}
					this.delKeys = JSON.parse(JSON.stringify(this.selectKeys))
					this.windowVeisible = true
				} else {
					this.$message.error(res.msg)
				}
			},
			windowHandleOk(){
				this.apiSalewindowEdit();
			},
			async apiSalewindowEdit() {
				this.windowConfirmLoading = true
				let addKeys = []
				for(let i=0; i<this.selectKeys.length; i++){
					let is = this.delKeys.indexOf(this.selectKeys[i])
					if(is > -1){
						this.delKeys.splice(is, 1)
					}else{
						addKeys.push(this.selectKeys[i])
					}
				}
				const { data: res } = await this.$http.post(this.navigation.apiSalewindowEditByPrice, {
					priceId:this.tableSelectedRows.priceId, delKeys:this.delKeys, addKeys:addKeys,
				});
				if (res.code == 200) {
					this.$message.success(res.msg)
	
					this.apiPriceQueryList()
					this.windowConfirmLoading = false
					this.windowVeisible = false
				} else {
					this.$message.error(res.msg)
					this.windowConfirmLoading = false
				}
			},
	
			handleWindowChange(targetKeys, direction, moveKeys){
				this.selectKeys = targetKeys;
			},
			//-----------------规则管理--------
			// 添加计费规则

			openBillingRule(item){
				this.priceId = item.priceId
				this.billingRuleVisible = true
			},
			billingRuleHandleOk() {
				this.$refs.billingRuleFrom.billingRuleHandleOk()
			},
			closeBillingRule() {
				this.apiPriceQueryList()
				this.billingRuleVisible = false
			},

			// 获取票价配置
			async apiPriceConfig(item) {
				const { data: res } = await this.$http.post(this.navigation.apiPriceConfig, {
					priceId:item.priceId,
				});
				return res;
			},

			// 添加打印模板
			async printTemplate(item){
				let res = await this.apiPriceConfig(item)
				if(res.code == 200 && res.data){
					this.printTemplateForm = {
						priceConfigId: res.data.priceConfigId,
						printTemplateId : res.data.printTemplateId,
						printSubTemplateId : res.data.printSubTemplateId,
					}
						
				}else{
					this.printTemplateForm.priceConfigId = item.priceId
					this.printTemplateForm.printTemplateId = 0
					this.printTemplateForm.printSubTemplateId = 0
				}
				this.printTemplateVisible = true
			},
			
			// 确认打印模板
			printTemplateHandleOk(){
				this.apiPricePrintTemplate()
			},
			async apiPricePrintTemplate() {
				this.printTemplateConfirmLoading = true
				const printTemplate = this.printTemplateList.find(item => item.printTemplateId == this.printTemplateForm.printTemplateId)
				const printSubTemplate = this.printSubTemplateList.find(item => item.printTemplateId == this.printTemplateForm.printSubTemplateId)
				const printTemplateForm = {
					priceConfigId: this.printTemplateForm.priceConfigId,
					printTemplateId : this.printTemplateForm.printTemplateId,
					printSubTemplateId : this.printTemplateForm.printSubTemplateId,
					printTemplateJson: printTemplate.templateJson,
					printSubTemplateJson: printSubTemplate.templateJson,
				}
				const { data: res } = await this.$http.post(this.navigation.apiPricePrintTemplate, printTemplateForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiPriceQueryList()
					this.printTemplateConfirmLoading = false
					this.printTemplateVisible = false
				} else {
					this.$message.error(res.msg)
					this.printTemplateConfirmLoading = false
				}
			},
			// 添加日价格
			priceDay(item){
				if(item.priceDayState == 2){
					this.$message.warning('当前选中的票价类型不是日期票')
					return
				}
				this.priceId = item.priceId
				this.startDate = item.startDate
				this.endDate = item.endDate
				this.salePrice = item.salePrice
				this.settlementPrice = item.settlementPrice
				this.priceDayVisible = true
			},
			priceDayHandleOk(){
				this.$refs.priceDayFrom.priceDayHandleOk()
			},
			closePriceDay() {
				this.apiPriceQueryList()
				this.priceDayVisible = false
			},
			// 添加优惠政策
			async priceDiscount(item){
				let res = await this.apiPriceConfig(item)
				if(res.code == 200 && res.data){
					this.priceDiscountForm = {
						priceConfigId: res.data.priceConfigId,
						priceDiscountId : res.data.priceDiscountId,
					}
				}else{
					this.priceDiscountForm.priceConfigId = item.priceId
					this.priceDiscountForm.priceDiscountId = 0
				}
				this.priceDiscountVisible = true
			},
			priceDiscountHandleOk(){
				this.apiPriceDiscount()
			},
			async apiPriceDiscount() {
				this.priceDiscountConfirmLoading = true
				const priceDiscountForm = {
					priceConfigId: this.priceDiscountForm.priceConfigId,
					priceDiscountId : this.priceDiscountForm.priceDiscountId,
				}
				const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountConfirm, priceDiscountForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiPriceQueryList()
					this.priceDiscountConfirmLoading = false
					this.priceDiscountVisible = false
				} else {
					this.$message.error(res.msg)
					this.priceDiscountConfirmLoading = false
				}
			},
			closePriceDiscount() {
				this.apiPriceQueryList()
				this.priceDiscountVisible = false
			},
		},
		

		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows[0];
					},
				};
			},
		},
		created() {
			this.apiSysparmListByName()
			this.apiCrowdtypeList()
			this.apiBusinesstypeList()
			this.apiPrintTemplateList()
			this.apiPriceDiscountList()
			setTimeout(()=>this.apiPriceQueryList(),500)
			
		}
	};
</script>

<style lang="less">
.qa-modal-day .ant-modal{
	top: 0 !important;
	height: 100%;
	padding: 0;
}
.qa-modal-day .ant-modal-content{
	height: 100%;
	background-color: #f5f5f5;
}
.qa-modal-day .ant-modal-body{
	padding: 0 !important;
}
</style>
